import React from 'react';
import { Layers, Shield, Wind, DollarSign } from 'lucide-react';
import { whyGwinsFeatures } from '../../data/mock';

const iconMap = {
  Layers,
  Shield,
  Wind,
  DollarSign,
};

const WhyGwins = () => {
  return (
    <section className="section-padding bg-[#0a0b0c]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-[#00d4aa] text-sm font-bold uppercase tracking-widest mb-4">
            The GWINS Difference
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black uppercase text-white mb-4">
            Why Choose <span className="text-[#00d4aa]">GWINS</span>
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto">
            Built for the battlefield. Every piece of gear is engineered for peak performance.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {whyGwinsFeatures.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group relative p-8 rounded-2xl bg-gradient-to-b from-[#131416] to-[#0a0b0c] border border-white/5 hover:border-[#00d4aa]/30 transition-all duration-300"
              >
                {/* Icon */}
                <div className="w-16 h-16 rounded-xl bg-[#00d4aa]/10 flex items-center justify-center mb-6 group-hover:bg-[#00d4aa]/20 transition-colors">
                  <IconComponent className="h-8 w-8 text-[#00d4aa]" />
                </div>

                {/* Content */}
                <h3 className="text-white text-xl font-bold mb-3">
                  {feature.title}
                </h3>
                <p className="text-white/60 leading-relaxed">
                  {feature.description}
                </p>

                {/* Hover glow effect */}
                <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                  style={{
                    background: 'radial-gradient(circle at center, rgba(0, 212, 170, 0.05) 0%, transparent 70%)'
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyGwins;
